import PropTypes from "prop-types"
import React, { useMemo } from "react"
import ClientRecordElement from "./clientRecordElement"
import CrmRecordElement from "./CrmRecordElement"
import dictionary from "../../utils/dictionary"
import { useSelector } from "react-redux"
import { isDayOffRecord } from "../../utils/dayOffServices"
import { ToastContainer } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"

const RecordsList = ({
  filteredRecords,
  pageType,
  setReset,
  hasMore,
  onLoadMore,
}) => {
  const selectedLanguage = useSelector((state) => state.lang.lang)

  const virtualItems = useMemo(() => {
    const records =
      pageType === "client"
        ? (filteredRecords ?? [])
        : (filteredRecords ?? []).filter((record) => !isDayOffRecord(record))

    return records.map((record, index, arr) => ({
      key: record.id,
      record,
      lastEl: index === arr.length - 1,
    }))
  }, [filteredRecords, pageType])

  if (!virtualItems.length) {
    return (
      <div className="text-darkBrown pt-[32px]">
        {dictionary[selectedLanguage].noData}
      </div>
    )
  }

  if (pageType === "client") {
    return (
      <div className="text-darkBrown pt-[32px] max-md:text-xs overflow-y-scroll max-h-[800px]">
        <div className="grid grid-cols-4 bg-lightGray border border-gray rounded-t-lg font-bold">
          <div className="py-[12px] px-[20px] max-md:py-[6px] max-md:px-[10px]">
            {dictionary[selectedLanguage].master}
          </div>
          <div className="py-[12px] px-[20px] max-md:py-[6px] max-md:px-[10px]">
            {dictionary[selectedLanguage].service}
          </div>
          <div className="py-[12px] px-[20px] max-md:py-[6px] max-md:px-[10px]">
            {dictionary[selectedLanguage].price}
          </div>
          <div className="py-[12px] px-[20px] max-md:py-[6px] max-md:px-[10px]">
            {dictionary[selectedLanguage].time}
          </div>
        </div>
        {virtualItems.map(({ record, lastEl }) => (
          <ClientRecordElement
            record={record}
            services={null}
            lastEl={lastEl}
            key={record.id}
          />
        ))}
      </div>
    )
  }

  return (
    <div className="text-darkBrown pt-[32px] max-md:text-xs">
      <div className="grid grid-cols-5 bg-lightGray border border-gray rounded-t-lg font-bold">
        <div className="py-[12px] px-[20px] max-md:py-[6px] max-md:px-[10px]">
          {dictionary[selectedLanguage].client}
        </div>
        <div className="py-[12px] px-[20px] max-md:py-[6px] max-md:px-[10px]">
          {dictionary[selectedLanguage].service}
        </div>
        <div className="py-[12px] px-[20px] max-md:py-[6px] max-md:px-[10px]">
          {dictionary[selectedLanguage].price}
        </div>
        <div className="py-[12px] px-[20px] max-md:py-[6px] max-md:px-[10px]">
          {dictionary[selectedLanguage].time}
        </div>
        <div className="py-[12px] px-[20px] max-md:py-[6px] max-md:px-[10px]">
          {dictionary[selectedLanguage].status}
        </div>
      </div>
      <div className="overflow-y-auto max-h-[800px]">
        {virtualItems.map(({ record, lastEl }) => (
          <CrmRecordElement
            key={record.id}
            record={record}
            lastEl={lastEl}
            records={filteredRecords}
            setReset={setReset}
          />
        ))}
      </div>
      {hasMore ? (
        <button
          type="button"
          className="mt-2 text-brown underline text-sm hover:opacity-80"
          onClick={onLoadMore}
        >
          …
        </button>
      ) : null}
      <ToastContainer
        position="top-right"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </div>
  )
}

RecordsList.propTypes = {
  filteredRecords: PropTypes.array,
  pageType: PropTypes.string.isRequired,
  setReset: PropTypes.func,
  hasMore: PropTypes.bool,
  onLoadMore: PropTypes.func,
}

export default RecordsList
